export const loginFormStyle = {
  wrapper: {
    marginTop: '140px',
    maxWidth: '374px',
    margin: '0 12px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',

    '@media (max-width: 1199.98px)': {
      height: 'calc(100vh - 80px)',
    },
  },
  marginTop: {
    margin: '0px 12px 0',
  },

  title: {
    paddingBottom: '16px',

    '& .MuiTypography-h5': {
      fontSize: '34px',
      lineHeight: '42px',
      textTransform: 'capitalize',
    },
  },

  email: {
    display: {
      xs: 'none',
      lg: 'block',
    },
    position: 'absolute',
    right: 0,
    color: 'var(--neutral-300)',
    fontWeight: 400,
    bottom: 0,
  },

  signUp: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    color: 'var(--neutral-500)',
    marginTop: '8px',
    gap: '4px',
  },
  margin: {},

  login: {
		display: 'flex',
		justifyContent: 'center',
		color: 'var(--neutral-500)',
	},

  link: {
    height: '24px',
    fontWeight: '400',
    fontSize: '16px',
    color: 'var(--primary-500)',
    textDecoration: 'none',

    '&:first-letter': {
      textTransform: 'uppercase',
    },
  },

  footer: {
    display: 'flex',
    gap: '40px',
    justifyContent: 'center',
    marginTop: 'auto',

    '@media (min-width: 1200px)': {
      display: 'none',
    },
  },

  text: {
    color: 'var(--neutral-300)',
    textDecoration: 'none',
  },

  modal: {
    '.MuiPaper-root': {
      maxWidth: '770px',
      padding: '48px 200px',
      width: '100%',

      '@media (max-width: 1199.98px)': {
        padding: '48px 120px',
      },

      '@media (max-width: 639.98px)': {
        padding: '40px 20px 20px',
      },
    },
  },
};
